import React, { useMemo } from "react";
import PropTypes from "prop-types";

import _str from "shared/util/_str";
import _strf from "shared/util/_strf";

import ActionPrompt from "apps/messenger/components/MainWindow/MessagePane/ActionPrompt";
import ActionPromptButton from "apps/messenger/components/MainWindow/MessagePane/ActionPromptButton";

const STATUS_MAP = {
	"Married": _str("Married"),
	"Seeing Someone": _str("Partnered"),
};

const MONOGAMY_MAP = {
	"monogamous": _str("Monogamous"),
	"non_monogamous": _str("Non-monogamous"),
	"open_to_either": _str("Open to either monogamy or non-monogamy"),
};

function getProfileLinkRequestInfo(props) {
	const results = {};

	if (props.isExpired) {
		results.text = _str("This request has expired.");
	} else if (props.isCanceled) {
		results.text = _str("This request has been canceled.");
	} else if (props.isAccepted) {
		results.text = _str("Your accounts are now linked.");

		results.primaryLabel = _str("Visit Them");
		results.onPrimary = () => { window.location = `/profile/${props.tuid}`; };
	} else if (props.isRejected) {
		results.text = _str("You rejected their request. If you changed your mind, you can send them a request yourself.");
	} else if (props.isValid) {
		if (props.monogamy) {
			results.text = _strf("By linking accounts, your settings will change to \"$status\" and \"$monogamy\", and a link to their profile will show up on yours.", {
				status: STATUS_MAP[props.relationshipStatus],
				monogamy: MONOGAMY_MAP[props.monogamy],
			});
		} else {
			results.text = _strf("By linking accounts, your relationship status will change to \"$status\", and a link to their profile will show up on yours.", {
				status: STATUS_MAP[props.relationshipStatus],
			});
		}

		results.primaryLabel = _str("Link accounts");
		results.onPrimary = () => props.onProfileLinkAccept(props.tuid);

		results.secondaryLabel = _str("No thanks");
		results.onSecondary = () => props.onProfileLinkReject(props.tuid, props.timestamp);
	}

	return results;
}

const ProfileLinkRequest = (props) => {
	// Recalculate this when props change.
	const results = useMemo(() => getProfileLinkRequestInfo(props), [props]);

	return (
		<ActionPrompt text={results.text}>
			<ActionPromptButton
				buttonType={ActionPromptButton.buttonType.secondary}
				onClick={results.onSecondary}
				label={results.secondaryLabel}
			/>
			<ActionPromptButton
				buttonType={ActionPromptButton.buttonType.primary}
				onClick={results.onPrimary}
				label={results.primaryLabel}
			/>
		</ActionPrompt>
	);
};

/* eslint-disable react/no-unused-prop-types */
ProfileLinkRequest.propTypes = {
	tuid: PropTypes.string.isRequired,
	timestamp: PropTypes.number.isRequired,
	relationshipStatus: PropTypes.string.isRequired,
	monogamy: PropTypes.string.isRequired,
	isValid: PropTypes.bool.isRequired,
	isRejected: PropTypes.bool.isRequired,
	isAccepted: PropTypes.bool.isRequired,
	isCanceled: PropTypes.bool.isRequired,
	isExpired: PropTypes.bool.isRequired,

	onProfileLinkAccept: PropTypes.func.isRequired,
	onProfileLinkReject: PropTypes.func.isRequired,
};
/* eslint-enable react/no-unused-prop-types */

export default ProfileLinkRequest;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/MessagePane/ProfileLinkRequest.jsx